import { useModalWithHashingControl } from '@app/components/ModalResponsive';
import UserInformationsManagerModal from '@app/components/UserInformationsManagerModal';
import { Address, DeliveryTypesAvailable } from '@app/types';
import { getFullAddressText } from '@app/utils/address';
import React from 'react';
import classes from './styles.module.css';

type Props = {
  address: Address | null;
  onAddressChange: (address: Address | null) => void;
  onContainerRef: (containerRef: HTMLElement | null) => void;
};

export default function AddressInformationBox({ address, onAddressChange, onContainerRef }: Props) {
  const addressModal = useModalWithHashingControl('endereco');

  function handleChangeAddressClick() {
    addressModal.open();
  }

  function handleSaveInformations(newAddress: Address | null) {
    console.log('NEW ADDRESS: ', newAddress);
    addressModal.close();
    onAddressChange(newAddress);
  }

  function getButtonLabel() {
    if (!address) return 'Adicionar endereço';
    return 'Editar';
  }

  return (
    <>
      <div className={classes.addressBox} ref={onContainerRef} onClick={handleChangeAddressClick}>
        <>
          <span>Endereço de entrega</span>
          {address && <p>{getFullAddressText(address)}</p>}
        </>
        <div className={classes.changeAddress}>{getButtonLabel()}</div>
      </div>
      <UserInformationsManagerModal
        isVisible={addressModal.state}
        onClose={() => addressModal.close()}
        address={address}
        onSave={handleSaveInformations}
        hiddenAddressInputs={false}
        hiddenUserInputs={true}
      />
    </>
  );
}
